import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  styled,
  MenuItem,
  TextField,
  FormControl,
} from "@mui/material";
import { get } from "../../../../utils/api";
const CustomTextField = styled(TextField)(({ theme, error }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  // "& .MuiSelect-select": {
  //     height: "56px", // Adjust height as needed
  //     display: "flex",
  //     alignItems: "center",
  // },
  ...(error && {
    "& .MuiOutlinedInput-root": {
      borderColor: "#D34040", // Red border on error
      "&:hover": {
        borderColor: "#D34040", // Keep red border on hover
      },
      "&.Mui-focused": {
        borderColor: "#D34040", // Keep red border when focused
      },
    },
  }),
}));

const SelectFieldMachineType = ({
  title,
  value,
  formData,
  handleChangeMachine,
  name,
  options,
  errors,
  url,
  field,
}) => {
  const [newOptions, setNewOptions] = useState([]);
  const [newOptionsName, setNewOptionsName] = useState([]);
  // Styled TextField with conditional error styling

  const EllipsisMenuItem = styled(MenuItem)(({ theme }) => ({
    overflow: "hidden",
    whiteSpace: "normal", // Allow text to wrap
    textOverflow: "clip", // No text overflow, allow wrap
    maxWidth: "300px", // You can adjust this or use width: '100%' for flexible sizing
    wordBreak: "break-word", // Ensures that long words break correctly and wrap to the next line
  }));

  // Fetch options
  const fetchOptions = async () => {
    try {
      const res = await get(url);
      const filteredData = res.data.data.filter(
        (item) => item.machineCategory?.type === formData?.machineryCategory
      );
      const NameFilters = res.data.data.filter(
        (item) => item.machineType?._id === formData?.machineryType
      );
      const uniqueOptions = Array.from(
        new Set(filteredData.map((item) => item.machineType?._id))
      ).map((uniqueId) => {
        const matchedItem = filteredData.find(
          (item) => item.machineType?._id === uniqueId
        );
        return {
          id: matchedItem.machineType?._id,
          name: matchedItem.machineType?.name,
        };
      });
      const uniqueOptionName = NameFilters.map((item) => {
        return {
          id: item._id,
          name: item.name,
        };
      });

      setNewOptions(uniqueOptions);
      setNewOptionsName(uniqueOptionName);
      console.log(
        "Processed Unique Options:",
        NameFilters,
        uniqueOptionName,
        uniqueOptions
      );
    } catch (err) {
      console.error("Error fetching options:", err);
    }
  };

  useEffect(() => {
    if (value !== "") {
      setNewOptions([value]);
    }
    if (url) {
      fetchOptions();
    }
  }, [formData?.machineryCategory, formData?.machineryType]);

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: "55%",
        overflowY: "auto",
        bgColor: "inherit",
      },
    },
  };

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
        {title}
      </Typography>

      <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
        <CustomTextField
          variant="outlined"
          select
          name={name}
          // className={disabled ? "highlight-disabled" : ""}
          value={value ? value : "Tap to select"} // Set value to an empty string if undefined
          onChange={handleChangeMachine}
          error={!!errors} // Pass error state to CustomTextField
          SelectProps={{ MenuProps }}
          disabled={
            (name === "machineryType" && formData?.machineryCategory === "") ||
            (name === "machineryName" && formData?.machineryType === "")
              ? true
              : false
          }
        >
          <MenuItem value="Tap to select" disabled>
            Tap to select
          </MenuItem>
          {(options && options.length > 0
            ? options
            : name === "machineryType"
            ? newOptions
            : newOptionsName
          ).map((option) => {
            return (
              <EllipsisMenuItem
                key={option.id || option}
                value={option.id || option?.name}
              >
                {option?.name || ""}
              </EllipsisMenuItem>
            );
          })}
        </CustomTextField>
        {errors && (
          <Typography variant="body2" color="#D34040">
            {errors}
          </Typography>
        )}
      </FormControl>
    </Box>
  );
};
export default SelectFieldMachineType;
